// extracted by mini-css-extract-plugin
export default {"card":"BoothAnalytics_card__QrJz8"};